'use strict';

var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;

var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));

var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));

var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));

var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));

var _react = _interopRequireWildcard(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _lodash = _interopRequireDefault(require('lodash'));

var _views = require('./views');

var _helpers = require('./helpers');

var _globalStyles = _interopRequireDefault(require('./globalStyles'));

function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}

function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2['default'])(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}

var renderSuppliers = /*#__PURE__*/ (function() {
    var _ref2 = (0, _asyncToGenerator2['default'])(
        /*#__PURE__*/ _regenerator['default'].mark(function _callee(_ref) {
            var env, setSuppliers, config, result, suppliers;
            return _regenerator['default'].wrap(function _callee$(_context) {
                while (1) {
                    switch ((_context.prev = _context.next)) {
                        case 0:
                            (env = _ref.env), (setSuppliers = _ref.setSuppliers), (config = _ref.config);
                            _context.next = 3;
                            return (0, _helpers.getSuppliers)(env);

                        case 3:
                            result = _context.sent;
                            suppliers = [];
                            result.fetchedData.Suppliers.map(function(supplier) {
                                if (
                                    config.suppliers.includes(supplier.Id) &&
                                    !_lodash['default'].find(suppliers, {
                                        Id: supplier.Id,
                                    })
                                )
                                    _lodash['default'].map(supplier.Contracts, function(contract) {
                                        if (contract.IsVisible === true && contract.CanPunchOut === true) {
                                            console.log('supplier', supplier);
                                            return suppliers.push(supplier);
                                        }
                                    });
                            });
                            console.log('SC :: renderSuppliers :: ', suppliers, result);
                            setSuppliers(suppliers);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee);
        }),
    );

    return function renderSuppliers(_x) {
        return _ref2.apply(this, arguments);
    };
})();

var updateRoute = function updateRoute(_ref3) {
    var choice = _ref3.choice,
        setTerm = _ref3.setTerm,
        router = _ref3.router,
        config = _ref3.config,
        env = _ref3.env;
    (0, _helpers.postAnalytics)(
        'store-choice-select',
        {
            store: config.title,
            choice: choice,
        },
        env,
    );
    setTerm(choice);
    if (router)
        router.history.push({
            pathame: '/stores',
            search: '?term='.concat(choice),
        });
};

var Store = function Store(props) {
    var router = props.router,
        apiUrl = props.apiUrl,
        blobUrl = props.blobUrl,
        apiKey = props.apiKey,
        bearerToken = props.bearerToken,
        userToken = props.userToken,
        mobile = props.mobile,
        onATC = props.onATC;
    var apiVersion = props.config.apiVersion;
    var routerTerm = router ? router.location.search.split('?term=')[1] : null;

    var _useState = (0, _react.useState)(null),
        _useState2 = (0, _slicedToArray2['default'])(_useState, 2),
        config = _useState2[0],
        setConfig = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
        loaded = _useState4[0],
        setLoaded = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = (0, _slicedToArray2['default'])(_useState5, 2),
        zip = _useState6[0],
        setZip = _useState6[1];

    var _useState7 = (0, _react.useState)(routerTerm),
        _useState8 = (0, _slicedToArray2['default'])(_useState7, 2),
        term = _useState8[0],
        setTerm = _useState8[1];

    var _useState9 = (0, _react.useState)(null),
        _useState10 = (0, _slicedToArray2['default'])(_useState9, 2),
        suppliers = _useState10[0],
        setSuppliers = _useState10[1];

    var _useState11 = (0, _react.useState)({
            apiKey: apiKey,
            apiUrl: apiUrl,
            bearerToken: bearerToken,
            userToken: userToken,
            blobUrl: blobUrl,
            onATC: onATC,
            apiVersion: apiVersion,
        }),
        _useState12 = (0, _slicedToArray2['default'])(_useState11, 2),
        env = _useState12[0],
        setEnv = _useState12[1];

    (0, _react.useEffect)(function() {
        var newEnv = {
            apiKey: apiKey,
            apiUrl: apiUrl,
            bearerToken: bearerToken,
            userToken: userToken,
            blobUrl: blobUrl,
            onATC: onATC,
            apiVersion: apiVersion,
        };
        console.log('SC :: SearchResults :: data :: ', term, suppliers, config);
        setLoaded(true);
        setEnv(newEnv);
    }, []);
    (0, _react.useEffect)(
        function() {
            if (loaded)
                setEnv({
                    apiKey: apiKey,
                    apiUrl: apiUrl,
                    bearerToken: bearerToken,
                    userToken: userToken,
                    blobUrl: blobUrl,
                    onATC: onATC,
                    apiVersion: apiVersion,
                });
        },
        [apiUrl, apiKey, bearerToken, userToken, blobUrl],
    );
    (0, _react.useEffect)(
        function() {
            renderSuppliers({
                env: env,
                setSuppliers: setSuppliers,
                config: props.config,
            });
            setConfig(null);
            setTerm(null);

            if (props.config && props.config.categories && props.config.categories.length === 1) {
                updateRoute({
                    choice: props.config.categories[0].name,
                    setTerm: setTerm,
                    router: router,
                    config: props.config,
                    env: env,
                });
            }
        },
        [props.config],
    );
    (0, _react.useEffect)(
        function() {
            if (!config) {
                var updatedConfig = _objectSpread({}, props.config);

                updatedConfig.categories = _lodash['default'].orderBy(props.config.categories, 'name', 'asc');
                setConfig(updatedConfig);
            }
        },
        [config],
    );

    if (config) {
        return /*#__PURE__*/ _react['default'].createElement(
            'div',
            {
                className: 'store-component',
            },
            /*#__PURE__*/ _react['default'].createElement(_globalStyles['default'], {
                mobile: mobile,
            }),
            term
                ? suppliers &&
                      /*#__PURE__*/ _react['default'].createElement(_views.SearchResults, {
                          config: config,
                          term: term,
                          zip: zip,
                          router: router,
                          env: env,
                          mobile: mobile,
                          suppliers: suppliers,
                          onBackClick: function onBackClick() {
                              return setTerm('');
                          },
                      })
                : /*#__PURE__*/ _react['default'].createElement(_views.SearchSelect, {
                      config: config,
                      onChoiceSelect: function onChoiceSelect(choice) {
                          return updateRoute({
                              choice: choice,
                              setTerm: setTerm,
                              router: router,
                              config: config,
                              env: env,
                          });
                      },
                      term: term,
                      zip: zip,
                      env: env,
                      mobile: mobile,
                      suppliers: suppliers,
                  }),
        );
    } else {
        return /*#__PURE__*/ _react['default'].createElement('div', null);
    }
};

Store.propTypes = {
    config: _propTypes['default'].object.isRequired,
    apiKey: _propTypes['default'].string.isRequired,
    apiUrl: _propTypes['default'].string.isRequired,
    blobUrl: _propTypes['default'].string.isRequired,
    bearerToken: _propTypes['default'].string.isRequired,
    userToken: _propTypes['default'].string.isRequired,
    mobile: _propTypes['default'].bool,
};
var _default = Store;
exports['default'] = _default;
